import { useEffect, useState } from "react";

// Zwraca true gdy klawiatura ekranowa jest otwarta (mobile).
// Wykrywamy to po skurczeniu visualViewport względem layoutu — focus nie wystarcza,
// bo po wyszukaniu input dalej ma focus, a klawiatura jest już schowana.
export const useKeyboardOpen = (threshold = 150): boolean => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const vv = window.visualViewport;
		if (!vv) return;

		const update = () => setOpen(window.innerHeight - vv.height > threshold);
		update();
		vv.addEventListener("resize", update);
		return () => vv.removeEventListener("resize", update);
	}, [threshold]);

	return open;
};
